import { UPDATE_TITLE } from './page-header-actions';

const initialState = {
    title: '',
    subTitle: ''
};

export default function (state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
    case UPDATE_TITLE:
        return {
            ...state,
            title: action.payload.title,
            subTitle: action.payload.subTitle
        };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./components/page-header/page-header-reducer.js